import Axios from "./user-panel/config/config";

export async function getUser() {
  try {
    const res = await Axios.get("auth/me");

    // auth/me directly user object return karta hai
    if (res.data?.id) {
      return res.data;
    }

    return null;
  } catch (err) {
    console.warn("Token expired or auth failed");
    return null;
  }
}

export async function logout() {
  try {
    await Axios.get("auth/logout");
  } catch (e) {
    console.error(e);
  } finally {
    document.cookie =
      "cf_at=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=None; Secure";

    document.cookie =
      "cf_rt=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=None; Secure";

    localStorage.removeItem("token_expired");
    localStorage.removeItem("user");
    localStorage.removeItem("user_info");
    try {
      sessionStorage.clear();
    } catch (e) {
      /* storage blocked */
    }

    // replace(): the dashboard is not kept as the current history entry
    window.location.replace("/signed-out");
  }
}